import { render, staticRenderFns } from "./BannerHeader.vue?vue&type=template&id=f582c3f8&scoped=true&"
import script from "./BannerHeader.vue?vue&type=script&lang=js&"
export * from "./BannerHeader.vue?vue&type=script&lang=js&"
import style0 from "./BannerHeader.vue?vue&type=style&index=0&id=f582c3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f582c3f8",
  null
  
)

export default component.exports